import { SizeParser } from '@common-vue/media-card-large/src/modules/size';
import { ColorParser } from '@common-vue/media-card-large/src/modules/color';
import { useProductType } from '@composables/useProductType';
import { useTopLevelCategoryFlags } from '@modules/featureControl';
import UpcLatchkeyParser from './UpcLatchkeyParser';
import LatchkeyNamesParser from './LatchkeyNamesParser';
import TypeParser from './deprecated/TypeParser.mcom';
import UpcLatchkeyParserMcom from './deprecated/UpcLatchkeyParser.mcom';
import ColorParserMcom from './deprecated/ColorParser.mcom';

/**
 * @returns {ParsedLatchkeys}
 */
function defaultValues() {
  return {
    latchkeyNames: [],
    latchkeyMap: {},
    latchkeySizeMap: {},
    latchkeyColorMap: {},
    latchkeyUpcMap: {},
  };
}

/**
 *
 * @param {Product} [product]
 * @returns {ParsedLatchkeys}
 */
export default function parser(product) {
  if (!product) {
    return defaultValues();
  }

  const { isConsolidatedLatchKey } = useProductType({ productId: product.id });

  if (!isConsolidatedLatchKey) {
    return defaultValues();
  }

  const latchkeyNames = LatchkeyNamesParser(product);

  // TODO fix type
  /** @type {Record<string, LatchkeyProduct>} */
  const latchkeyMap = {};

  /** @type {Record<string, import('@common-vue/media-card-large/src/features/size/types').ParsedSizes>} */
  const latchkeySizeMap = {};

  /** @type {Record<string, ParsedColors>} */
  const latchkeyColorMap = {};

  const latchkeyUpcMap = {};

  latchkeyNames.forEach((latchkeyName) => {
    const latchkeyProduct = product.relationships.latchKeyToProductMap[latchkeyName];
    latchkeyMap[latchkeyName] = latchkeyProduct;
    latchkeySizeMap[latchkeyName] = SizeParser(latchkeyProduct); // TODO fix type
    const parsedColors = ColorParser({ ...latchkeyProduct, urlTemplate: product.urlTemplate });
    latchkeyColorMap[latchkeyName] = {
      ...parsedColors,
      selectedColor: parsedColors.colorArray[0]?.id || -1,
    };

    latchkeyUpcMap[latchkeyName] = UpcLatchkeyParser(product, latchkeyProduct); // TODO fix type

    const {
      isMattressesCategory,
      isComfortersCategory,
      isMenCategory,
      isWomenCategory,
      isJuniorCategory,
    } = useTopLevelCategoryFlags();

    const shouldUseSize = isMenCategory || isWomenCategory || isJuniorCategory;

    // Temp implementation for MCOM until xapi migrates to use same data struture as BCOM
    // Once migration is completed just delete this block and the imported files
    const numTypes = Object.keys(latchkeyProduct.traits.types?.typeMap || {}).length;
    if (numTypes > 0 && !shouldUseSize) {
      latchkeySizeMap[latchkeyName] = TypeParser(latchkeyProduct);
      ColorParserMcom(latchkeyColorMap, latchkeySizeMap);
      UpcLatchkeyParserMcom({
        upcMap: latchkeyUpcMap[latchkeyName].upcMap,
        colorMap: latchkeyColorMap[latchkeyName],
        sizeMap: latchkeySizeMap[latchkeyName],
        useColorArray: isMattressesCategory || isComfortersCategory,
      });
    }
  });

  return {
    latchkeyNames,
    latchkeyMap,
    latchkeySizeMap,
    latchkeyColorMap,
    latchkeyUpcMap,
  };
}
